export const defaults = {
  data: {}
};
